/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DasUBootGameMode} from "../server/DasUBootGameMode";
import {LoopableList} from "../utils/LoopableList";
import {DasUBootRoundType} from "../server/DasUBootData";
import {IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {gsap} from "gsap";
import {DasUBoot} from "../DasUBoot";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";


export enum DasUBootMusic {
    MAIN_GAME_MUSIC = "background-music-main",
    FREESPIN_MUSIC = "freespin",
    FREESPIN_INTRO_MUSIC = "freespinIntro",
    SUPER_FREESPIN_MUSIC = "superFreespin",
    SUPER_FREESPIN_INTRO_MUSIC = "superFreespinIntro"
}

export class DasUBootSound {

    public static AS_WIN:string = "asWin";
    public static AS_WIN_BIG:string = "asWinBig";


    public static REELS_SPINNING:string = "reelsSpinning";


    private static davidPanningReelStop:number[] = [-0.14, -0.07, -0.01, 0.01, 0.07, 0.14];
    public static reelsLanding = new LoopableList<string>([
        "reelLanding1",
        "reelLanding2",
        "reelLanding3",
        "reelLanding4",
        "reelLanding5",
        "reelLanding6"
    ]).setRandomizeAtWrapAround(true);


    static FS_OUTRO_SWEEP:string = "fsOutroSweep";
    static FS_OUTRO:string = "fsOutro";
    static FREESPIN_MUSIC_OUTRO:string = "fsEnds";
    static SUPER_FREESPIN_MUSIC_OUTRO:string = "fsEndsSuper";

    private _currentMusic:string;

    public static COUNT_UP:string = "countup";
    public static COUNT_UP_END_TINY:string = "countupEndsTiny";
    public static COUNT_UP_END_SMALL:string = "countupEndsSmall";
    public static COUNT_UP_END_MEDIUM:string = "countupEndsMedium";
    public static COUNT_UP_END_LARGE:string = "countupEndsLarge";


    public static FREESPIN_RE_TRIGGER:string = "freespinRetrigger";


    static BIG_WIN_MUSIC:string = "bigwin";
    static BIG_WIN_INTRO:string = "bigwinIntro";
    static BIG_WIN_LEVEL_1:string = "bigwinLevel1";
    static BIG_WIN_LEVEL_2:string = "bigwinLevel2";
    static BIG_WIN_LEVEL_3:string = "bigwinLevel3";
    static BIG_WIN_LEVEL_4:string = "bigwinLevel4";
    static BIG_WIN_END:string = "bigwinEnds";


    public player:NolimitAudioPlayer;
    static WIN_TINY:string = "winTiny";
    static WIN_SMALL:string = "winSmall";
    static WIN_MEDIUM:string = "winMedium";
    static WIN_LARGE:string = "winLarge";

    private countUpLoop:boolean = false;
    static LOWER_TORPEDO:string = "lowerTorpedo";

    static TORPEDO_COVER_DOWN:string = "torpedoCoverDown";
    static TORPEDO_COVER_UP:string = "torpedoCoverUp";
    static TORPEDO_COVER_OPEN:string = "torpedoCoverOpen";
    static TORPEDO_COVER_CLOSE:string = "torpedoCoverClose";
    static TORPEDO_DOWN:string = "torpedoDown";
    static TORPEDO_UP:string = "torpedoUp";
    static TORPEDO_LAUNCH:string = "torpedoLaunch";
    static TORPEDO_SYMBOLS_REVEAL:string = "torpedoSymbolsReveal";


    static RAISE_PERISCOPE:string = "raisePeriscope";
    public static NEAR_WIN_ANTICIPATION:string = "anticipation";
    public static NEAR_WIN_ANTICIPATION_FAIL:string = "anticipationFail";

    public static INTRO_FREE_SPIN:string = "introFreeSpin";
    private static INTRO_FREE_SPIN_ALARM:string ="introFreeSpinAlarm";

    public static INTRO_SUPER_FREE_SPIN:string = "introSuperFreeSpin";
    public static INTRO_SUPER_FREE_SPIN_ALARM:string = "introSuperFreeSpinAlarm";

    static MAX_WIN:string = "maxWin";
    static MAX_WIN_MUSIC:string = "maxWinMusic";
    static MAX_WIN_MUSIC_ENDS:string = "maxWinMusicEnds";

    public static NEAR_WIN_ANTICIPATION_PERISCOPE:string = "anticipationPeriscope";
    public static NEAR_WIN_ANTICIPATION_WIN_PERISCOPE:string = "anticipationWinPeriscope";
    public static NEAR_WIN_ANTICIPATION_FAIL_PERISCOPE:string = "anticipationFailPeriscope";
    private _nearWinStarted:boolean;


    public static scatterLandingSounds = new LoopableList<string>([
        "scatterLanding1",
        "scatterLanding2",
        "scatterLanding3",
        "scatterLanding4"
    ]);

    public static avalancheLandingSounds = new LoopableList<string>([
        "avalancheSymbolLand1",
        "avalancheSymbolLand2",
        "avalancheSymbolLand3",
    ]);
    static BOMB_LANDING_SOUND:string = "bombWildLanding";
    static BOMB_EXPLODE_SOUND:string = "bombWildExplode";
    public static symbolExplodeSounds = new LoopableList<string>([
        "symbolExplode1",
        "symbolExplode2",
        "symbolExplode3",
    ]);

    static SCATTER_LANDING:string = "scatterLanding";
    static SCATTER_LANDING_FS:string = "scatterLandingFs";
    static PERISCOPE_SYMBOL_LANDING:string = "periscopeLanding";
    static PERISCOPE_SYMBOL_EXPANDING:string = "periscopeExpand";
    static TORPEDO_LANDING:string = "torpedoLanding";
    static TORPEDO_WELD:string = "torpedoWeld";
    static TORPEDO_MISS:string = "torpedoMiss";

    static XWAY_LANDING:string = "xWayLanding";
    static XWAY_RESCALE:string = "xWayRescale";
    static XWAY_REVEAL:string = "xWayReveal";

    static WILD_LANDING:string = "wildLanding";
    static WILD_NUDGE:string = "wildNudge";
    static WILD_NUDGE_MULTIPLIER:string = "wildNudgeMultiplier";
    static WILD_NUDGE_MULTIPLIER_DOWN:string = "wildNudgeMultiplierDown";
    static WILD_NUDGE_TRANSFORM:string = "wildNudgeTransform";


    static PERISCOPE_WILD_NUDGE:string = "periscopeWildNudge";
    static PERISCOPE_MISS_VERDAMMT:string = "periscopeMissVerdammt";
    static PERISCOPE_MISS_SCHEISSE:string = "periscopeMissSheisse";
    static PERISCOPE_MISS_MIST:string = "periscopeMissMist";
    static PERISCOPE_HIT:string = "periscopeHit";
    private currentWinSound:string;

    static X_BOMB_COUNTER_UPDATE:string = "xBombCounterUpdate";
    static X_BOMB_COUNTER_TICK:string = "xBombCounterTick";

    static POSSIBLE_WIN_WAYS_DISPLAY_TICK:string = "possibleWinWaysDisplayTick";
    static POSSIBLE_WIN_WAYS_DISPLAY_STEAM:string = "possibleWinWaysAir";

    static COUNT_MULTIPLIER:string = "countupMultiplier";
    static COUNT_MULTIPLIER_ENDS:string = "countupMultiplierEnds";


    private _isPlayingBigWin:boolean = false;
    static POTENTIAL_WIN:string = "potentialWin";

    private _periscopeNearWinStarted:boolean = false;
    static X_BOMB_LIGHTNING:string = "xBombLightning";
    static X_BOMB_ALARM:string = "xBombAlarm";
    static AIR_PRESSURE_1:string = "airPressure1";
    static AIR_PRESSURE_2:string = "airPressure2";
    static AIR_PRESSURE_3:string = "airPressure3";
    static AIR_PRESSURE_END_2:string = "airPressure2Ends";
    static AIR_PRESSURE_END_3:string = "airPressure3Ends";
    static CONTINUE_BUTTON:string ="continueButton";
    static SCHEISSE_MORSE:string = "scheisseMorse";





    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound
    }

    private static createConfig(name:string, volume?:number, repeat?:number):IPlayTrackConf {
        return {
            name:name,
            volume:volume,
            repeat:repeat
        }
    }

    public playSound(name:string, volume?:number,  repeat?:number):void {
        Logger.log("playSound: " + name);
        this.playAndGetSound(name,volume,repeat);
    }

    public playAndGetSound(name:string, volume?:number, repeat?:number):NolimitHowl | undefined {
        if (repeat == -1) {
            const nHowl = this.player.playTrack(DasUBootSound.createConfig(name, volume));
            if (nHowl) {
                nHowl.setLoop(true);
            }

        }
        return this.player.playTrack(DasUBootSound.createConfig(name, volume, repeat));
    }

    public stopSound(name:string):NolimitHowl | undefined {
        return this.player.stopTrack(name);
    }

    public fadeAndStop(name:string, durationMs:number) {
        const sound:NolimitHowl | undefined = this.player.fetchSoundPlayer(name);
        if (sound) {
            const tl:gsap.core.Timeline = gsap.timeline();
            tl.add([
                gsap.to(this, {duration:durationMs*0.001}),
                () => sound.fade(1, 0, durationMs)
            ]);
            tl.add(() => sound.stop());
        }
    }


    public playReelStopSound(reel:number) {
        const soundName = DasUBootSound.reelsLanding.next();
        const sound:NolimitHowl | undefined = this.playAndGetSound(soundName);
        if (sound) {
            sound.player.stereo(DasUBootSound.davidPanningReelStop[reel])
        }

    }

    public playMaxWinSound() {
        this.fadeOutMusic(1500);
        this.playSound(DasUBootSound.MAX_WIN);
    }

    playFsOutro() {
        if (this._currentMusic == DasUBootMusic.FREESPIN_MUSIC) {
            this.player.stopTrack(this._currentMusic);
            this.playSound(DasUBootSound.FREESPIN_MUSIC_OUTRO);
        } else {
            this.player.stopTrack(this._currentMusic);
            this.playSound(DasUBootSound.SUPER_FREESPIN_MUSIC_OUTRO);
        }

        this.playSound(DasUBootSound.FS_OUTRO, 1,-1);


        const nextMusic = DasUBootMusic.MAIN_GAME_MUSIC;
        const thing:NolimitHowl | undefined = this.player.playTrack(DasUBootSound.createConfig(nextMusic, 0));
        if (thing) {
            thing.fade(0, 1, 1500);
        }
        this._currentMusic = nextMusic;

    }

    public switchMusic(song:DasUBootMusic) {
        if (song == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }

        this.player.playTrack(DasUBootSound.createConfig(song));
        this._currentMusic = song;
    }

    public startCountUp() {
        if (!this.countUpLoop) {
            this.player.playTrack(DasUBootSound.createConfig(DasUBootSound.COUNT_UP, undefined, 1000));
        }
        this.countUpLoop = true;
    }

    public endCountUp(endSound:string) {
        if (this.countUpLoop) {
            if (endSound != "") {
                this.playSound(endSound);
            }
            this.stopSound(DasUBootSound.COUNT_UP);
            this.countUpLoop = false;
        }
    }

    public fadeOutMusic(duration:number = 300, targetVolume:number = 0) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name:this._currentMusic,
                to:targetVolume,
                duration:duration
            });
        }
    }

    public fadeInMusic(duration:number = 300) {
        if (this._currentMusic) {
            this.player.fadeTrack({
                name:this._currentMusic,
                to:1,
                duration:duration
            });
        }
    }

    public playWinSound(name:string) {
        this.stopSound(this.currentWinSound);
        this.playSound(name);
        this.currentWinSound = name;
    }

    public startNearWin() {
        if (!this._nearWinStarted) {
            this._nearWinStarted = true;
            this.playSound(DasUBootSound.NEAR_WIN_ANTICIPATION);
            this.fadeOutMusic(500, 0.5);
        }
    }

    public stopNearWin(nextMode:DasUBootGameMode) {
        if (this._nearWinStarted) {
            this._nearWinStarted = false;
            this.stopSound(DasUBootSound.NEAR_WIN_ANTICIPATION);
            this.fadeInMusic(10);

            if (nextMode != DasUBootGameMode.FREESPIN && nextMode != DasUBootGameMode.SUPER_FREESPIN) {
                this.playSound(DasUBootSound.NEAR_WIN_ANTICIPATION_FAIL);
            }

        }
    }

    public startPeriscopeNearWin() {
        if (!this._periscopeNearWinStarted) {
            this._periscopeNearWinStarted = true;
            this.playSound(DasUBootSound.NEAR_WIN_ANTICIPATION_PERISCOPE);
            this.fadeOutMusic(500, 0.5);
        }
    }

    public stopPeriscopeNearWin(hitPeriscopeSymbol:boolean = false) {
        if (this._periscopeNearWinStarted) {
            this._periscopeNearWinStarted = false;
            this.stopSound(DasUBootSound.NEAR_WIN_ANTICIPATION_PERISCOPE);
            this.fadeInMusic(10);
            if (hitPeriscopeSymbol) {
                //this.playSound(DasUBootSound.NEAR_WIN_ANTICIPATION_WIN_PERISCOPE);
            } else {
                this.playSound(DasUBootSound.NEAR_WIN_ANTICIPATION_FAIL_PERISCOPE);
            }
        }
    }

    public playSingleSound(name:string) {
        this.stopSound(name);
        this.playSound(name);

    }

    public startBigWinMusic() {
        if (!this._isPlayingBigWin) {
            this._isPlayingBigWin = true;
            this.playSound(DasUBootSound.BIG_WIN_MUSIC, 1, -1);
        }
    }

    public stopBigWinMusic() {
        if (this._isPlayingBigWin) {
            this.stopSound(DasUBootSound.BIG_WIN_MUSIC);
            this._isPlayingBigWin = false;
        }

    }

    startLampBlinkLoop() {
        this.playSound(DasUBootSound.X_BOMB_ALARM, undefined, -1);
    }

    stopLampBlinkLoop() {
        this.fadeAndStop(DasUBootSound.X_BOMB_ALARM, 300);
    }

    playScatterLanding(scatters:number) {
        if (DasUBoot.model.data.roundType != DasUBootRoundType.NORMAL){
            this.playSound(DasUBootSound.SCATTER_LANDING_FS);
        } else {
            this.playSound(DasUBootSound.SCATTER_LANDING + scatters);
        }
    }

    public playIntroSound(roundType:DasUBootRoundType) {
        const tl:gsap.core.Timeline = gsap.timeline();
        if (roundType == DasUBootRoundType.FREE_SPIN){
            tl.add(()=>this.playSound(DasUBootSound.INTRO_FREE_SPIN));
            tl.add(()=>{
                this.playSound(DasUBootSound.INTRO_FREE_SPIN_ALARM,1,-1);
                this.switchMusic(DasUBootMusic.FREESPIN_INTRO_MUSIC)
            },0.918);
        } else {
            tl.add(()=>this.playSound(DasUBootSound.INTRO_SUPER_FREE_SPIN));
            tl.add(()=>{
                this.playSound(DasUBootSound.INTRO_SUPER_FREE_SPIN_ALARM,1,-1);
                this.switchMusic(DasUBootMusic.SUPER_FREESPIN_INTRO_MUSIC)
            },0.918);
        }
    }

    public stopIntroSound(roundType:DasUBootRoundType){
        if (roundType == DasUBootRoundType.FREE_SPIN){
            this.stopSound(DasUBootSound.INTRO_FREE_SPIN_ALARM);
            this.switchMusic(DasUBootMusic.FREESPIN_MUSIC);
        }
        else {
            this.stopSound(DasUBootSound.INTRO_SUPER_FREE_SPIN);
            this.stopSound(DasUBootSound.INTRO_SUPER_FREE_SPIN_ALARM);
            this.switchMusic(DasUBootMusic.SUPER_FREESPIN_MUSIC);
        }
    }
}